export default __webpack_public_path__ + "static/media/title.e1c4a9b5.png";